import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Lightning, List, X } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";

export const Navbar = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  return (
    <header className="fixed top-0 inset-x-0 z-50 glass" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="navbar-logo">
          <div className="w-8 h-8 rounded-md bg-[#FF3B6B] flex items-center justify-center shadow-[0_0_24px_-4px_#FF3B6B]">
            <Lightning weight="fill" className="text-white" size={18} />
          </div>
          <span className="font-semibold tracking-tight text-lg">ClipForge<span className="text-[#FF3B6B]">AI</span></span>
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm text-white/70">
          <a href="/#features" className="hover:text-white transition-colors" data-testid="nav-features">Features</a>
          <a href="/#how" className="hover:text-white transition-colors" data-testid="nav-how">How it works</a>
          <Link to="/pricing" className="hover:text-white transition-colors" data-testid="nav-pricing">Pricing</Link>
          <a href="/#leaderboard" className="hover:text-white transition-colors" data-testid="nav-leaderboard">Ambassadors</a>
          <Link to="/blog" className="hover:text-white transition-colors" data-testid="nav-blog">Blog</Link>
          <Link to="/help" className="hover:text-white transition-colors" data-testid="nav-help">Help</Link>
        </nav>
        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <button onClick={() => nav("/app")} className="px-4 py-2 rounded-md btn-primary text-sm font-medium" data-testid="nav-dashboard-btn">
              Open Dashboard
            </button>
          ) : (
            <>
              <Link to="/auth" className="text-sm text-white/70 hover:text-white" data-testid="nav-signin">Sign in</Link>
              <Link to="/auth?mode=signup" className="px-4 py-2 rounded-md btn-primary text-sm font-medium" data-testid="nav-getstarted">
                Get started
              </Link>
            </>
          )}
        </div>
        <button className="md:hidden text-white" onClick={() => setOpen(!open)} data-testid="nav-toggle">
          {open ? <X size={22} /> : <List size={22} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-white/10 px-6 py-4 space-y-3 bg-[#0A0A0A]">
          <a href="/#features" onClick={() => setOpen(false)} className="block text-white/80 py-1" data-testid="mobile-nav-features">Features</a>
          <a href="/#how" onClick={() => setOpen(false)} className="block text-white/80 py-1" data-testid="mobile-nav-how">How it works</a>
          <Link to="/pricing" onClick={() => setOpen(false)} className="block text-white/80 py-1" data-testid="mobile-nav-pricing">Pricing</Link>
          <a href="/#leaderboard" onClick={() => setOpen(false)} className="block text-white/80 py-1" data-testid="mobile-nav-leaderboard">Ambassadors</a>
          <Link to="/blog" onClick={() => setOpen(false)} className="block text-white/80 py-1" data-testid="mobile-nav-blog">Blog</Link>
          <Link to="/help" onClick={() => setOpen(false)} className="block text-white/80 py-1" data-testid="mobile-nav-help">Help & Support</Link>
          <a href="/#faq" onClick={() => setOpen(false)} className="block text-white/80 py-1" data-testid="mobile-nav-faq">FAQ</a>
          {user ? (
            <Link to="/app" onClick={() => setOpen(false)} className="block btn-primary px-4 py-2 rounded text-center mt-2" data-testid="mobile-nav-dashboard">Dashboard</Link>
          ) : (
            <>
              <Link to="/auth" onClick={() => setOpen(false)} className="block text-white/80 py-1 border-t border-white/10 pt-3" data-testid="mobile-nav-signin">Sign in</Link>
              <Link to="/auth?mode=signup" onClick={() => setOpen(false)} className="block btn-primary px-4 py-2 rounded text-center" data-testid="mobile-nav-getstarted">Get Started</Link>
            </>
          )}
        </div>
      )}
    </header>
  );
};
